import { InjectionToken } from '@angular/core';
export var CONFIGURE_PROJECT_INFO = new InjectionToken('CONFIGURE_PROJECT_INFO');
